import computed from './computed'
import data from './data'
import methods from './methods'

export default {
  computed,
  data,
  methods,
  resourcePath: ''
}



// WEBPACK FOOTER //
// ./src/crud/resources/index.js